module.exports = __webpack_public_path__ + "img/tube_white.c5c00516.svg";